export var calculateEstimateCost = function (allJobs, roadTestData) {
    var _allJobs$additionalJo;
    var cost = 0;
    var labourCost = 0;
    var partCost = 0;
    var autoPopulateLabourCost = 0;
    var autoPopulatePartCost = 0;
    var declinedAdditionalJobs = [];
    var calculateJobArrayCost = function (jobArray) {
        jobArray.forEach(function (element) {
            if (!(element !== null && element !== void 0 && element.isExpanded)) {
                var _element$SelectedPric, _element$SelectedPric3;
                if ((element === null || element === void 0 ? void 0 : element.jobType) === "Labour" && element !== null && element !== void 0 && (_element$SelectedPric = element.SelectedPriceDetails) !== null && _element$SelectedPric !== void 0 && _element$SelectedPric.Amount) {
                    var _element$SelectedPric2;
                    labourCost += Number(element === null || element === void 0 || (_element$SelectedPric2 = element.SelectedPriceDetails) === null || _element$SelectedPric2 === void 0 ? void 0 : _element$SelectedPric2.Amount);
                }
                else if (element !== null && element !== void 0 && (_element$SelectedPric3 = element.SelectedPriceDetails) !== null && _element$SelectedPric3 !== void 0 && _element$SelectedPric3.Amount) {
                    var _element$SelectedPric4;
                    partCost += Number(element === null || element === void 0 || (_element$SelectedPric4 = element.SelectedPriceDetails) === null || _element$SelectedPric4 === void 0 ? void 0 : _element$SelectedPric4.Amount);
                }
            }
        });
    };
    calculateJobArrayCost(allJobs.periodicJobs);
    calculateJobArrayCost(allJobs.standardJobs);
    roadTestData === null || roadTestData === void 0 || roadTestData.forEach(function (element) {
        if (!(element !== null && element !== void 0 && element.isExpanded)) {
            if (element !== null && element !== void 0 && element.LabourPrice) {
                labourCost += Number(element === null || element === void 0 ? void 0 : element.LabourPrice);
            }
            if (element !== null && element !== void 0 && element.PartPrice) {
                partCost += Number(element === null || element === void 0 ? void 0 : element.PartPrice);
            }
        }
    });
    allJobs === null || allJobs === void 0 || (_allJobs$additionalJo = allJobs.additionalJobs) === null || _allJobs$additionalJo === void 0 || _allJobs$additionalJo.forEach(function (element) {
        if (!(element !== null && element !== void 0 && element.isExpanded)) {
            if ((element === null || element === void 0 ? void 0 : element.AutofillType) !== 2) {
                var _element$SelectedPric5, _element$SelectedPric6;
                if ((element === null || element === void 0 ? void 0 : element.jobType) === "Labour" && element !== null && element !== void 0 && (_element$SelectedPric5 = element.SelectedPriceDetails) !== null && _element$SelectedPric5 !== void 0 && _element$SelectedPric5.Amount) {
                    labourCost += Number(element.SelectedPriceDetails.Amount);
                }
                else if (element !== null && element !== void 0 && (_element$SelectedPric6 = element.SelectedPriceDetails) !== null && _element$SelectedPric6 !== void 0 && _element$SelectedPric6.Amount) {
                    var _element$SelectedPric7;
                    partCost += Number(element === null || element === void 0 || (_element$SelectedPric7 = element.SelectedPriceDetails) === null || _element$SelectedPric7 === void 0 ? void 0 : _element$SelectedPric7.Amount);
                }
            }
            else {
                var _element$SelectedPric8, _element$SelectedPric9;
                if (element.jobType === "Labour" && (_element$SelectedPric8 = element.SelectedPriceDetails) !== null && _element$SelectedPric8 !== void 0 && _element$SelectedPric8.Amount) {
                    autoPopulateLabourCost += Number(element.SelectedPriceDetails.Amount);
                }
                else if (element !== null && element !== void 0 && (_element$SelectedPric9 = element.SelectedPriceDetails) !== null && _element$SelectedPric9 !== void 0 && _element$SelectedPric9.Amount) {
                    var _element$SelectedPric10;
                    autoPopulatePartCost += Number(element === null || element === void 0 || (_element$SelectedPric10 = element.SelectedPriceDetails) === null || _element$SelectedPric10 === void 0 ? void 0 : _element$SelectedPric10.Amount);
                }
            }
            declinedAdditionalJobs.push(element);
        }
    });
    cost = labourCost + partCost;
    return {
        cost: cost,
        labourCost: labourCost,
        partCost: partCost,
        autoPopulateLabourCost: autoPopulateLabourCost,
        autoPopulatePartCost: autoPopulatePartCost,
        declinedAdditionalJobs: declinedAdditionalJobs
    };
};
